import React from "react";
import type { ErrorScreenProps } from "../../types/errors";
import { getErrorDetails } from "../../utils/errorMapper";
import errorImage from "../../assets/images/error.webp";
import Button from "./Button";

const ErrorScreen: React.FC<ErrorScreenProps> = ({
  errorType,
  title,
  message,
  onRetry,
  retrying = false,
}) => {
  const details = errorType ? getErrorDetails({ type: errorType }) : null;

  const displayTitle = title || details?.title || "Something Went Wrong";
  const displayMessage =
    message ||
    details?.message ||
    "An unexpected error occurred. Please try again";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <img
        src={errorImage}
        alt="Error"
        width={300}
        height={300}
        style={{
          maxWidth: "300px",
          width: "100%",
          height: "auto",
          marginBottom: "2rem",
        }}
      />
      <h2
        style={{
          color: "#ffffff",
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "1rem",
          textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
        }}
      >
        {displayTitle}
      </h2>
      <p
        style={{
          color: "#ffffff",
          fontSize: "1.125rem",
          marginBottom: "2rem",
          maxWidth: "500px",
          textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
        }}
      >
        {displayMessage}
      </p>
      {onRetry && (
        <Button
          text={retrying ? "Retrying..." : "Try Again"}
          onClick={onRetry}
          disabled={retrying}
        />
      )}
    </div>
  );
};

export default ErrorScreen;
